import { useTranslation } from "react-i18next";
import { Result, Button } from "antd";

function NotAuthorizedPage() {
  const { t } = useTranslation();
  const origin = window.location.origin;

  return (
    <Result
      status="403"
      title="403"
      subTitle={t("error.403")}
      extra={
        <Button type="primary" href={origin}>
          {t("button.go_home")}
        </Button>
      }
    />
  );
}

export default NotAuthorizedPage;
